(function () {
  const animationSelector = [
    '.animate-fade-in',
    '.animate-fade-in-top',
    '.animate-fade-in-bottom',
    '.animate-fade-in-left',
    '.animate-fade-in-right'
  ].join(',');

  let observer = null;

  function initAnimations(root = document) {
    const elements = root.querySelectorAll(animationSelector);

    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.classList.add('is-animated');
      });

      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-animated');

            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -40px 0px'
        }
      );
    }

    elements.forEach((element) => {
      if (
        !element.classList.contains('is-animated') &&
        element.dataset.hmAnimationObserved !== 'true'
      ) {
        element.dataset.hmAnimationObserved = 'true';
        observer.observe(element);
      }
    });
  }

  function start() {
    initAnimations(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /*
   * Shopify Theme Editor support
   */
  document.addEventListener('shopify:section:load', (event) => {
    initAnimations(event.target);
  });
})();